import { AppDispatch, RootState } from "redux/store";
import {
  SET_SIGN_UP_MODAL_IS_OPEN,
  SET_FREE_TRIAL_REQUEST_MODAL_IS_OPEN,
  SET_USER_ROLES_MODAL_IS_OPEN,
  SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE,
  SET_SHOW_SIGN_UP_MODAL_ON_CLOSE
} from './types'

export const setSignUpModalIsOpen = (isOpen: boolean) => ({
  type: SET_SIGN_UP_MODAL_IS_OPEN,
  isOpen
})

export const setFreeTrialRequestModalIsOpen = (isOpen: boolean) => (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch({
    type: SET_FREE_TRIAL_REQUEST_MODAL_IS_OPEN,
    isOpen
  })
  const { modals: { freeTrialRequest: { showSignUpModalOnClose } } } = getState()
  if (!isOpen && showSignUpModalOnClose) {
    dispatch(setSignUpModalIsOpen(true))
  }
}

export const setUserRolesModalIsOpen = (isOpen: boolean) => ({
  type: SET_USER_ROLES_MODAL_IS_OPEN,
  isOpen
})

export const setUserRolesModalIsBasicMessage = (isBasicMessage: boolean) => ({
  type: SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE,
  isBasicMessage
})

export const setShowSignUpModalOnFreeTrialModalClose = (showSignUpModal: boolean) => ({
  type: SET_SHOW_SIGN_UP_MODAL_ON_CLOSE,
  showSignUpModalOnClose: showSignUpModal
})
